import disabilityLabelsRevised from './disabilityLabelsRevised';

export const getDisabilityLabels = () => {
  return disabilityLabelsRevised;
};
